__webpack_require__.p = "/frontend/apps/p2pRegistration/build/";